module.exports = __webpack_public_path__ + "static/media/cuib.7c7e0578.png";